import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {TaskModel} from "../../../../tasks/models/task.model";
import {
  CdkDrag,
  CdkDragDrop,
  CdkDragEnter,
  CdkDropList,
  moveItemInArray,
  transferArrayItem
} from "@angular/cdk/drag-drop";
import * as _ from "lodash";
import {TaskPurposeType} from "../../../../commons/types/task-purpose.type";
import {TaskType} from "../../../../tasks/types/task.type";
import {TaskStatusType} from "../../../../tasks/types/taskStatus.type";

require('./agent-itinerary-edit-list.scss');
@Component({
  standalone: false,
  selector: 'app-agent-itinerary-edit-list',
  templateUrl: './agent-itinerary-edit-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentItineraryEditListComponent implements OnInit, OnChanges {

  @Input() tasks: TaskModel[];
  @Input() isLoading: boolean;
  @Output() onDragStart = new EventEmitter<any>();
  @Output() onTasksChange = new EventEmitter<any>();

  public editableTasks: TaskModel[];

  private internalTaskTypes = [TaskPurposeType.StartRoute, TaskPurposeType.EndRoute, TaskPurposeType.StartDay, TaskPurposeType.EndDay];

  constructor() {

  }

  ngOnInit() {
    this.editableTasks = _.cloneDeep(this.tasks || []);
    this.sortPredicate = this.sortPredicate.bind(this);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.tasks && !changes.tasks.isFirstChange()) {
      if (this.tasks?.length) {
        this.editableTasks = _.cloneDeep(this.tasks);
      }
    }
  }

  sortPredicate(index: number, item: CdkDrag<TaskModel>, drop: CdkDropList) {

    const itemRouteId = item.data.routeId;
    const ItemServiceIds = item.data.bundleServiceIdList ? item.data.bundleServiceIdList : [item.data.serviceId];

    const startIndex = !!itemRouteId ? _.findIndex(drop.data, (t: any) => {
      return this._isInternalTask(t) && (t.routeId === itemRouteId) && ((t.taskSpec.purpose === TaskPurposeType.StartDay) || (t.taskSpec.purpose === TaskPurposeType.StartRoute));
    }) : undefined
    const endIndex = !!itemRouteId ? _.findIndex(drop.data, (t: any) => {
      return this._isInternalTask(t) && (t.routeId === itemRouteId) && ((t.taskSpec.purpose === TaskPurposeType.EndDay) || (t.taskSpec.purpose === TaskPurposeType.EndRoute));
    }) : undefined
    const firstStartableTaskIndex = _.findIndex(drop.data, (t: any) => {
      return !this._isInternalTask(t) && ((t.status !== TaskStatusType.CourierHeading) && (t.status !== TaskStatusType.CourierArrived));
    })

    if (((startIndex > -1) && (startIndex >= index)) || ((endIndex > -1) && endIndex <= index)) {
      return false;
    }


    const isHeadingOrArrived = (item.data?.status === TaskStatusType.CourierHeading) || (item.data?.status === TaskStatusType.CourierArrived);

    if (!!isHeadingOrArrived) {
      if (index >= firstStartableTaskIndex) {
        return false;
      }
    } else if (index < firstStartableTaskIndex) {
      return false;
    }

    const connectedIndexes = [];

    drop.data.forEach((t, i) => {
      const serviceIds = t.bundleServiceIdList || [t.serviceId];
      if ((item.data.id !== t.id) && !!_.intersection(serviceIds, ItemServiceIds).length) {
        connectedIndexes.push(i)
      }
    })

    if (connectedIndexes.length) {

      let canMove = true;

      if (item.data.taskSpec.purpose === 'Pickup') {
        connectedIndexes.forEach((i) => {
          if (i <= index) {
            canMove = false;
          }
        })
        return canMove;
      }

      if (item.data.taskSpec.purpose === 'Dropoff') {
        connectedIndexes.forEach((i) => {
          if (i >= index) {
            canMove = false;
          }
        })
        return canMove;
      }

    } else {
      return true;
    }
  }

  enter(event: CdkDragEnter) {

  }

  drop(event: CdkDragDrop<string[]>) {

    if (!event.isPointerOverContainer) {
      return false;
    }

    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }

    const taskIds = _.map(event.container.data, 'id');
    this.onTasksChange.emit(taskIds);
  }

  private _isInternalTask(task: TaskModel) {
    const isInternalBundle = (task.taskType === TaskType.BundledStopover) && _.includes(this.internalTaskTypes, task.taskSpec.purpose);
    return !!isInternalBundle || _.isEqual(task.taskType, TaskType.Internal);
  }

}
